import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('invy_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid, clear it and redirect to login
      localStorage.removeItem('invy_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Locations
export const getLocations = () => api.get('/locations');
export const getLocation = (id) => api.get(`/locations/${id}`);
export const createLocation = (data) => api.post('/locations', data);
export const updateLocation = (id, data) => api.put(`/locations/${id}`, data);
export const deleteLocation = (id) => api.delete(`/locations/${id}`);
export const getLocationContainers = (id) => api.get(`/locations/${id}/containers`);

// Containers
export const getContainers = () => api.get('/containers');
export const getContainer = (id) => api.get(`/containers/${id}`);
export const getContainerHierarchy = (id) => api.get(`/containers/${id}/hierarchy`);
export const getContainerChildren = (id) => api.get(`/containers/${id}/children`);
export const getContainerItems = (id) => api.get(`/containers/${id}/items`);
export const createContainer = (data) => api.post('/containers', data);
export const updateContainer = (id, data) => api.put(`/containers/${id}`, data);
export const deleteContainer = (id) => api.delete(`/containers/${id}`);

// Items
export const getItems = () => api.get('/items');
export const getItem = (id) => api.get(`/items/${id}`);
export const getItemByBarcode = (barcode) => api.get(`/items/barcode/${barcode}`);
export const searchItems = (query) => api.get(`/items/search?q=${encodeURIComponent(query)}`);
export const lookupBarcode = (barcode) => api.get(`/items/lookup/${barcode}`);
export const createItem = (data) => api.post('/items', data);
export const updateItem = (id, data) => api.put(`/items/${id}`, data);
export const deleteItem = (id) => api.delete(`/items/${id}`);

// QR Codes
export const generateQRCode = (id) => api.get(`/qrcode/generate/${id}`);
export const generateQRCodeSVG = (id) => api.get(`/qrcode/generate/${id}/svg`);

export default api;
